"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitTicks = void 0;
async function waitTicks(amount) {
    for (let i = 0; i < amount; i++) {
        await Promise.resolve();
    }
}
exports.waitTicks = waitTicks;
//# sourceMappingURL=index.js.map